var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel-content',{attrs:{"value":_vm.open,"hide-actions":_vm.hideActions,"expand-icon":("bexsicon-" + (_vm.open ? 'minus' : 'plus') + " expansion-icon-size " + _vm.iconClassModifier)}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a6fe32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/ExpansionPanel.vue
// module id = null
// module chunks = 